<template>
  <b-modal ref="modal" size="lg" centered laze @hidden="onHide" :visible="true" no-fade>
    <div slot="modal-header" class="row justify-content-between align-items-center w-100 no-gutters">
      <h5 class="modal-title col-10">Tracking Information for {{ tracking_number }}</h5>
      <div class="col-2 text-right">
        <b-btn :variant="statusVariant">{{$t('status.' + status)}}</b-btn>
        <!-- <button @click="onHide" type="button" aria-label="Close" class="close">×</button> -->
      </div>
      <div class="col-12"></div>
      <!-- <p v-if="data.currentStatus && data.currentStatus.scanDescription" :class="['font-weight-bold', 'col-12', 'mb-0', statusClass]">{{ data.currentStatus.scanDescription }}, {{ getDate(currentStatus) | utcDate('MMMM D, YYYY, [by] h:mm A') }}</p> -->
      <p v-if="items[0].scanDescription" :class="['font-weight-bold', 'col-12', 'mb-0', statusClass]">{{ items[0].scanDescription }}, {{ getDate(items[0]) | utcDate('MMMM D, YYYY, [by] h:mm A') }}</p>
    </div>

    {{ /* no sure why causing weird error */ }}
    <!-- <b-table :items="items" striped show-empty>
      <template slot="empty" slot-scope="scope">
        <h6 class="text-center">No tracking found.</h6>
      </template>
    </b-table> -->

    <div v-for="(item, i) in items" :key="i">
      {{ getDate(item) | utcDate }} <br>
      {{ item.scanDescription || '' }} <br>
      {{ item.eventCity || '' }} {{ item.eventStateOrProvince || '' }} {{ item.postalCode || '' }}

      <hr class="border-top" v-if="(i + 1) < items.length">
    </div>

    <div slot="modal-footer">
      <b-btn
        style="background-color: #858888; border: 1px solid #858888;"
        @click="onHide"
      >Close</b-btn>
    </div>
  </b-modal>
</template>

<style lang="scss">
.f-blue {
  color: #042462;
}
.f-green {
  color: #4da030;
}
.f-red {
  color: #dc3545;
}
</style>

<script>
import formatters from "../formatters";
import moment from "moment";

export default {
  props: {
    orderType: {
      type: Object
    },
    data: {
      type: Object
    }
  },
  // data() {
  //   return {
  //     // it's causing weird errors
  //     fields: [
  //       {
  //         key: "eventDate",
  //         label: "Date"
  //       },
  //       {
  //         key: "eventTime",
  //         label: "Time"
  //       },
  //       {
  //         key: "eventCity",
  //         label: "City"
  //       },
  //       {
  //         key: "eventStateOrProvince",
  //         label: "State/Province"
  //       },
  //       /*{
  //         key: "postalCode",
  //         label: "Postal Code"
  //       },*/
  //       {
  //         key: "scanDescription",
  //         label: "Description"
  //       },
  //       {
  //         key: "packageStatus",
  //         label: "Status"
  //       }
  //     ]
  //   };
  // },
  computed: {
    status() {
      const { order } = this.data;
      try{
        switch(this.orderType.id){
          case 4:
            return order.label.refund_status;
          break;
          case 5:
            return order.label.status_return;
          break;
          default:
            return order.label.status;
        }
      }catch(e){
        console.error(e);
      }
    },
    tracking_number(){
      if (this.data.trackingDetails) {
        return this.data.trackingDetails.trackingNumber;
      }
      return this.data.label.tracking_id;
    },
    items() {
      const { trackingDetails } = this.data;
      console.log('tracking details', trackingDetails);
      if (trackingDetails) {
        return trackingDetails.scanDetailsList;
      }
      return null;
    },
    statusClass() {
      switch (this.status) {
        case "label_created":
          return "f-blue";
        case "in_transit":
          return "f-blue";
        case "delivered":
          return "f-green";
        case "undelivered":
          return "f-red";
        case "exception":
          return "f-red";
        default:
          return "f-blue";
      }
    },
    statusVariant() {
      switch (this.status) {
        case "label_created":
          return "primary";
          break;
        case "in_transit":
          return "primary";
          break;
        case "delivered":
          return "success";
          break;
        case "undelivered":
        case "exception":
          return "danger";
          break;
      }
      return "primary";
    },
  },
  methods: {
    onHide() {
      this.$emit("hide");
    },

    getDate(item) {
      return `${item.eventDate} ${item.eventTime}`
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/TrackingModal.vue